import React, { useContext } from "react";
import { DataContext } from "../../DataContext";
import Slider from "react-slick";
import "./Banner.scss";
import useCityContent from "../../hooks/useCityContent";
import TrinTrinImage from "../../images/trin-trin-mybyk.svg";
const Banner = () => {
  const { cityData } = useCityContent();
  const { data } = useContext(DataContext);
  const updatedSubscriptionAmount = data?.updatedSubscriptionAmount || 500;
  const planOriginalValue = data?.planOriginalValue;
  const subDurationValue = data?.subscriptionDuration || 30;
  const subscriptionDepositAmount = data?.subscriptionDepositAmount || 500;

  // Mapping durations to labels
  const durationMapping = {
    1: "Daily",
    3: "Every 3 Days",
    7: "Weekly",
    15: "Bi-Weekly",
    30: "Monthly",
    60: "Every 2 Months",
    90: "Quarterly",
    180: "Half-Yearly",
    365: "Yearly"
  };

  const subDuration = `${durationMapping[subDurationValue]}`;


  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  const getCityClass = (cityName) => {
    switch (cityName) {
      case "ahmedabad":
        return "ahmedabad";
      case "jhansi":
        return "jhansi";
      case "kochi":
        return "kochi";
      case "indore":
        return "indore";
      case "mysuru":
        return "mysuru";
      default:
        return "";
    }
  }
  return (
    <section className="banner ">
      {Array.isArray(cityData.banner_slider) && cityData.banner_slider.length > 0 ? (
        cityData.banner_slider.length > 1 ? (
          <Slider {...settings} className="banner-slider">
            {cityData.banner_slider.map((image, index) => (
              <div key={index}>
                <div
                  className="banner-slide"
                  style={{ backgroundImage: `url(${image})` }}
                />
              </div>
            ))}
          </Slider>
        ) : (
          <div className="banner-slider">
            <div className={`banner-slide position-bottom ${getCityClass(cityData.city_name)}`} style={{ backgroundImage: `url(${cityData.banner_slider[0]})` }} />
          </div>
        )
      ) : null}

      <div className="container">
        {cityData.city_name === "mysuru" && (
          <figure className="fig-trin">
            <img src={TrinTrinImage} alt="" />
          </figure>
        )}
        <div className="banner-content">

          <h1 className={`dynamic-text ${getCityClass(cityData.city_name)}`}>
            {cityData.banner_heading_local}
          </h1>
          <h2 className="sub-heading">
            Welcome to hassle free cycling
          </h2>

          {data &&
            <div className="banner-content__section">
              <p>Your all-inclusive bike subscription
                <span>with free repairs and maintenance.</span></p>
              <div className="banner-content__section-pricing">
                <div className="monthly-payment">
                  {(planOriginalValue !== null && planOriginalValue !== undefined && planOriginalValue !== 0) && (
                    <span className="old-price"><b className="rupee-symbol">₹</b>{planOriginalValue}</span>
                  )}
                  <h2><b className="rupee-symbol">₹</b>{updatedSubscriptionAmount}<span>{subDuration} Rent</span></h2>
                </div>
                <div className="plus">+</div>
                <div className="deposit">
                  <h2><b className="rupee-symbol">₹</b>{subscriptionDepositAmount}<span>Refundable Deposit</span></h2>
                </div>
              </div>
            </div>}
        </div>
      </div>
    </section>
  );
};

export default Banner;
